<script setup lang="ts">
import type { Locales } from '@/services/types/api.types';
import { useField } from 'vee-validate';
import { type Ref, ref, watch } from 'vue';

const props = defineProps<{
  name: string;
  label: string;
  languageEnabled?: Locales[];
}>();

const { value: value, errorMessage: errorMessage } = useField<Locales[] | null | undefined>(props.name);
const locales: Ref<{ label: string; languageCode: Locales }[]> = ref(
  [
    { label: 'FR', languageCode: 'fr' as Locales },
    { label: 'EN', languageCode: 'en' as Locales },
  ].filter((x) => !props.languageEnabled || props.languageEnabled.includes(x.languageCode)),
);

const languageModel = ref<any>({
  fr: value.value?.includes('fr') ?? false,
  en: value.value?.includes('en') ?? false,
});

const update = () => {
  value.value = ['fr', 'en'];
  if (!languageModel.value.fr) {
    value.value = value.value.filter((lang) => lang !== 'fr');
  }
  if (!languageModel.value.en) {
    value.value = value.value.filter((lang) => lang !== 'en');
  }
};

watch(value, (newValue) => {
  languageModel.value.fr = newValue?.includes('fr') ?? false;
  languageModel.value.en = newValue?.includes('en') ?? false;
});
</script>

<template>
  <div class="language-selector">
    <q-item tag="label" v-ripple v-for="lang in locales" :key="lang.languageCode">
      <q-item-section avatar>
        <q-toggle v-model="languageModel[lang.languageCode]" v-bind="$attrs" @update:model-value="update" />
      </q-item-section>
      <q-item-section>
        <q-item-label>{{ lang.label }}</q-item-label>
      </q-item-section>
    </q-item>
    <p>{{ errorMessage }}</p>
  </div>
</template>
<style lang="scss">
.language-selector {
  display: flex;
  flex-direction: row;
}
</style>
